import { baseCrudFactory } from "~/stores/base.crud.store"
import { usePersonnelStore } from "~/stores"
import { Api } from "~/api/Api"
import { EntrepriseModel } from "~/model"

export const useEntrepriseStore = baseCrudFactory({
    endpoint: "admin/company",
    primaryKey: "ID",
    title: "entreprise",
    model: EntrepriseModel,
    modules: {
        personnels: () => usePersonnelStore(),
    },
    actions: {
        async getCompanyFromDomain() {
            const response = await Api.auth.authGetCurentCompany()
            this.setItems(response)
            return response
        },
    },
})
